import React, { Component } from "react";
import logo from "../images/Logo-lg.png";
import Slider from "react-slick";
import StyledHero from "./StyledHero";

import img1 from "../images/bg.png";
import img2 from "../images/bg2.png";
import img3 from "../images/bg3.png";
import imgmb1 from "../images/bg-mobile.png";
import imgmb2 from "../images/bg-mobile2.png";
import imgmb3 from "../images/bg-mobile3.png";

export default class Hero extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
    };
    return (
      <>
        <div className="container">
          <Slider {...settings}>
            <StyledHero className="header" img={img1}>
              <div className="header-content">
                <img src={logo} alt="logo" />
                <h1>Banana Foster Ice cream cake</h1>
                <p>
                  If you're looking for decadence, look no further — you've
                  found the Holy Grail of desserts. Honestly, this cake makes us
                  wonder why Bananas Foster hasn't always been served on top of
                  ice cream cake.
                </p>
                <a href="/featured/f1" className="btn">
                  Get recipe
                </a>
              </div>
            </StyledHero>
            <StyledHero className="header" img={img2}>
              <div className="header-content">
                <img src={logo} alt="logo" />
                <h1>Moroccan Pastilla</h1>
                <p>
                  Pastilla, or bastilla, is a Moroccan pie, which looks dead
                  impressive but is surprisingly easy to make. It doesn’t matter
                  if it’s not that neat – we like rustic. We used pistachio nuts
                  when we cooked this in Fez for our telly show, but the locals
                  prefer almonds. The choice is yours.
                </p>
                <a href="/featured/f2" className="btn">
                  Get recipe
                </a>
              </div>
            </StyledHero>
            <StyledHero className="header" img={img3}>
              <div className="header-content">
                <img src={logo} alt="logo" />
                <h1>Moroccan Couscous with Seven Vegetables</h1>
                <p>
                  Couscous with Seven Vegetables also referred to as Couscous
                  Bidaoui, in reference to the Arabic name for Casablanca, where
                  this version of the dish originated. The recipe here is as
                  authentic as it gets. Meat or chicken is stewed with a variety
                  of vegetables in ample broth generously seasoned with ginger,
                  pepper and turmeric. Ideally the stewing is done in the base
                  of a couscoussier while the couscous grains steam above.
                </p>
                <a href="/featured/f3" className="btn">
                  Get recipe
                </a>
              </div>
            </StyledHero>
          </Slider>
          <div className="header-mobile">
            <Slider {...settings}>
              <div className="header-mobile-content">
                <img src={imgmb1} alt="" />
                <div className="btn-container">
                  <a href="/" className="btn btn-mobile">
                    Get recipe
                  </a>
                </div>
              </div>
              <div className="header-mobile-content">
                <img src={imgmb2} alt="" />
                <div className="btn-container">
                  <a href="/" className="btn btn-mobile">
                    Get recipe
                  </a>
                </div>
              </div>
              <div className="header-mobile-content">
                <img src={imgmb3} alt="" />
                <div className="btn-container">
                  <a href="/" className="btn btn-mobile">
                    Get recipe
                  </a>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </>
    );
  }
}
